









import IssueReceiptAction from "@/actions/IssueReceiptAction";
import { PublishmentOrder } from "@/interfaces/publishmentorder";
import Vue, { PropType } from "vue";
export default Vue.extend({
  props: {
    publishmentOrder: Object as PropType<PublishmentOrder>
  },
  methods: {
    async click() {
      const publishmentOrder = await this.$store.dispatch(
        "loadResource",
        this.publishmentOrder["@id"]
      );

      IssueReceiptAction(
        publishmentOrder,
        "receipt-" +
          (publishmentOrder.advertisement || {}).formattedAdvertisementId +
          ".pdf"
      );
    }
  }
});
